module.exports = __webpack_public_path__ + "static/media/fb.137cb6eb.svg";